namespace GeniuzPOS.Inventory {
    export namespace PermissionKeys {
        export const Inventory = "";

        namespace para {
            export const Modify = "2Inventory:\u0E23\u0E30\u0E1A\u0E1A:\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E23\u0E30\u0E1A\u0E1A\u0E2A\u0E15\u0E4A\u0E2D\u0E01:Modify";
            export const View = "2Inventory:\u0E23\u0E30\u0E1A\u0E1A:\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E23\u0E30\u0E1A\u0E1A\u0E2A\u0E15\u0E4A\u0E2D\u0E01:View";
        }

        namespace Bacprocess {
            export const Modify = "2Inventory:\u0E23\u0E30\u0E1A\u0E1A:\u0E1B\u0E23\u0E30\u0E21\u0E27\u0E25\u0E1C\u0E25\u0E2A\u0E34\u0E49\u0E19\u0E27\u0E31\u0E19:Modify";
            export const View = "2Inventory:\u0E23\u0E30\u0E1A\u0E1A:\u0E1B\u0E23\u0E30\u0E21\u0E27\u0E25\u0E1C\u0E25\u0E2A\u0E34\u0E49\u0E19\u0E27\u0E31\u0E19:View";
        }

        namespace IcStkAdjCode {
            export const Modify = "2Inventory:\u0E23\u0E30\u0E1A\u0E1A:\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E2A\u0E15\u0E4A\u0E2D\u0E01:Modify";
            export const View = "2Inventory:\u0E23\u0E30\u0E1A\u0E1A:\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E2A\u0E15\u0E4A\u0E2D\u0E01:View";
        }

        namespace IcStockReceive {
            export const Modify = "2Inventory:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:\u0E23\u0E31\u0E1A\u0E40\u0E02\u0E49\u0E32:Modify";
            export const View = "2Inventory:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:\u0E23\u0E31\u0E1A\u0E40\u0E02\u0E49\u0E32:View";
        }

        namespace IcStockReturnOut {
            export const Modify = "2Inventory:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:\u0E2A\u0E48\u0E07\u0E04\u0E37\u0E19:Modify";
            export const View = "2Inventory:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:\u0E2A\u0E48\u0E07\u0E04\u0E37\u0E19:View";
        }

        namespace IcStockSold {
            export const Modify = "2Inventory:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:\u0E40\u0E1A\u0E34\u0E01\u0E02\u0E32\u0E22:Modify";
            export const View = "2Inventory:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:\u0E40\u0E1A\u0E34\u0E01\u0E02\u0E32\u0E22:View";
        }

        namespace IcStockReturnIn {
            export const Modify = "2Inventory:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:\u0E23\u0E31\u0E1A\u0E04\u0E37\u0E19:Modify";
            export const View = "2Inventory:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:\u0E23\u0E31\u0E1A\u0E04\u0E37\u0E19:View";
        }

        namespace IcStockAdjust {
            export const Modify = "2Inventory:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07:Modify";
            export const View = "2Inventory:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07:View";
        }

        namespace IcStockTransfer {
            export const Modify = "2Inventory:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:\u0E42\u0E2D\u0E19\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E04\u0E25\u0E31\u0E07:Modify";
            export const View = "2Inventory:\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:\u0E42\u0E2D\u0E19\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E04\u0E25\u0E31\u0E07:View";
        }

        namespace IcStockCount {
            export const Modify = "2Inventory:\u0E15\u0E23\u0E27\u0E08\u0E19\u0E31\u0E1A:\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:Modify";
            export const View = "2Inventory:\u0E15\u0E23\u0E27\u0E08\u0E19\u0E31\u0E1A:\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:View";
        }

        namespace IcStockCountApprove {
            export const Modify = "2Inventory:\u0E15\u0E23\u0E27\u0E08\u0E19\u0E31\u0E1A:\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:Modify";
            export const View = "2Inventory:\u0E15\u0E23\u0E27\u0E08\u0E19\u0E31\u0E1A:\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:View";
        }

        namespace IcStockAseen_DisDoc {
            export const Modify = "2Inventory:\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32:\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:Modify";
            export const View = "2Inventory:\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32:\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23:View";
        }

        namespace IcStockAseen_DisDocApprove {
            export const Modify = "2Inventory:\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32:\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:Modify";
            export const View = "2Inventory:\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32:\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:View";
        }

        namespace IcStockWhs {
            export const Modify = "2Inventory:\u0E1B\u0E23\u0E30\u0E21\u0E27\u0E25\u0E1C\u0E25\u0E2A\u0E15\u0E4A\u0E2D\u0E01:Modify";
            export const View = "2Inventory:\u0E1B\u0E23\u0E30\u0E21\u0E27\u0E25\u0E1C\u0E25\u0E2A\u0E15\u0E4A\u0E2D\u0E01:View";
        }

        namespace IcStockReport {
            export const View = "2Inventory:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E07\u0E40\u0E2B\u0E25\u0E37\u0E2D:View";
        }

        namespace IcStockReportV {
            export const View = "2Inventory:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E21\u0E39\u0E25\u0E04\u0E48\u0E32:View";
        }

        namespace IcStockCard {
            export const View = "2Inventory:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E2A\u0E15\u0E4A\u0E2D\u0E01\u0E01\u0E32\u0E23\u0E4C\u0E14:View";
        }

        namespace IcStockReportEOM {
            export const View = "2Inventory:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E2A\u0E15\u0E4A\u0E2D\u0E01\u0E04\u0E07\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E2A\u0E34\u0E49\u0E19\u0E40\u0E14\u0E37\u0E2D\u0E19:View";
        }

        namespace IcStockTran {
            export const View = "2Inventory:\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E2B\u0E27\u0E2A\u0E15\u0E4A\u0E2D\u0E01:View";
        }
    }
}
